import { type LeaderboardData } from '../types/league';

const getUserLeagueScore = (
  data: LeaderboardData | undefined,
): number | undefined => {
  if (!data?.currentUserPosition?.users) {
    return;
  }

  const userPositionData = data.currentUserPosition.users.find(
    (item) => item.position === data.currentUserPosition.position,
  );

  if (!userPositionData) {
    return;
  }

  return Number(userPositionData.score);
};

export { getUserLeagueScore };
